
<div class="card">
  <div class="card-body text-center">
    @if (parameterService.queryParams.showamazon === '1')
    {
      <lib-frontend-amazonpay-autorize-capture/>
    }
    @if (parameterService.queryParams.showamazon === '2')
    {
      <lib-frontend-amazonpay-checkout/>
    }
  </div>
</div>
